const teamMembers = [
  {
    id: 1,
    name: 'Evelyne Mwangi',
    role: 'Captain',
    note: 'Leads the overall direction of the community and represents the club at university and AWS events.',
    initials: 'EM',
    image: '/images/team/evelyne-mwangi.jpg',
    socials: { linkedin: '#', github: '#' },
  },
  {
    id: 2,
    name: 'Alvine Lumiti',
    role: 'Technical Lead',
    note: 'Guides members through AWS projects, runs technical workshops, and supports certification journeys.',
    initials: 'AL',
    image: '/images/team/lumiti-alvine.jpeg',
    socials: {
      linkedin: 'https://www.linkedin.com/in/alvine-lumiti/',
      github: 'https://github.com/Mal-archLumi',
    },
  },
  {
    id: 3,
    name: 'Hinzano Kinga',
    role: 'UI & Design Lead',
    note: 'Shapes the visual identity of the community across events, content, and digital platforms.',
    initials: 'HK',
    image: '/images/team/hinzano-kinga.jpg',
    socials: { linkedin: '#' },
  },
  {
    id: 4,
    name: 'Joan Ngugi',
    role: 'Marketing & Communications Lead',
    note: 'Manages social media, promotes events, and grows awareness of the club on campus.',
    initials: 'JN',
    image: '/images/team/joan-ngugi.jpg',
    socials: { linkedin: '#' },
  },
  {
    id: 5,
    name: 'Lynn Ngugi',
    role: 'Community & Events Lead',
    note: 'Coordinates community engagement, organises events, and keeps members connected and active.',
    initials: 'LN',
    image: '/images/team/lynn-ngugi.jpg',
    socials: { linkedin: '#' },
  },
];

export default teamMembers;
